import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './pages/general/components/loader/loader.component';
import { MultiLanguageModule } from './pages/general/components/multi-language/multi-language/multi-language.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { ActivityService } from './pages/general/services/activity.service';
import { SessionService } from './pages/general/services/session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterLink,MultiLanguageModule, NgxSpinnerModule,
    RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit,OnDestroy {
  title = 'NGA_NG_NEXTGEN_PORTAL';
  userActivity:any;
  private activitySubscription: Subscription|any;
  userInactive: Subject<any> = new Subject();
  constructor(private keycloakservice:KeycloakService,private activityService: ActivityService,
    private sessionService: SessionService){
    // this.setTimeout();
    // this.userInactive.subscribe(() => {
    //   alert("There is no Acitivity for a while. So we close the session.")
    //   this.logout(); 
    // });
  }
  ngOnInit(): void {
    this.activitySubscription = this.activityService.active$.subscribe(isActive => {
      if (isActive) {
        this.sessionService.updateSession();
      }
    });
  }
  ngOnDestroy() {
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
  }
  // @HostListener('window:mousemove') refreshUserState() {
  //   this.resetTimeout();
  // }

  // @HostListener('window:click') onWindowClick() {
  //   this.resetTimeout();
  // }

  // @HostListener('window:keydown') onWindowKeydown() {
  //   this.resetTimeout();
  // }

  // @HostListener('window:scroll') onWindowScroll() {
  //   this.resetTimeout();
  // }

  // resetTimeout() {
  //   clearTimeout(this.userActivity);
  //   this.setTimeout();
  // }

  // setTimeout() {
  //   const timeInMilliseconds = 20 * 60 * 1000; // 10 minutes in milliseconds
  //   this.userActivity = setTimeout(() => this.userInactive.next(undefined), timeInMilliseconds);
  // }


  logout(){
    this.keycloakservice.logout();
}
}
